<template>
  <AgentLayout>
    <CourseSkeleton v-if="!course" />
    <div v-else class="mx-auto w-full max-w-5xl px-4 pb-20 sm:px-8">
      <CourseHero :course="course" />
      <CourseCurriculum :course="course" />
    </div>
  </AgentLayout>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { Api } from '@/api';
import AgentLayout from '@/components/layouts/AgentLayout/index.vue';
import CourseHero from '@/components/agent/university/CourseHero.vue';
import CourseCurriculum from '@/components/agent/university/CourseCurriculum.vue';
import CourseSkeleton from '@/components/agent/university/CourseSkeleton.vue';
import type { CourseWithSections } from '@/api/agent/university/course';

const route = useRoute();

const course = ref<CourseWithSections | null>(null);

const loadCourse = async () => {
  const response = await Api.AgentUniversityCourse.getCourse(String(route.params.slug));
  if (response.status === 'success') {
    course.value = response.data;
  }
};

onMounted(loadCourse);
</script>
